import { Box, Divider, Flex, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import type { ParticipantNachversandResDto } from '@web/common';
import { formatPart2Date } from '../utils';

export const NachversandHistory = ({
  history,
}: {
  history: ParticipantNachversandResDto['history'];
}) => {
  const { t } = useTranslation('versand');

  if (history.length === 0) {
    return (
      <Text size="16px" c="#666">
        {t('History.Empty')}
      </Text>
    );
  }

  return (
    <Flex direction="column" w="100%">
      {history.map((entry, index) => (
        <Box key={`${entry.date.toISOString()}-${entry.status}`}>
          {index > 0 && <Divider />}
          <Flex justify="space-between" gap="16px" py="12px" wrap="wrap">
            <Text size="16px" c="#202020">
              {formatPart2Date(entry.date)}
            </Text>
            <Text size="16px" c="#202020" fw={500}>
              {t(`History.Status.${entry.status}`)}
            </Text>
          </Flex>
        </Box>
      ))}
    </Flex>
  );
};
